
import { View } from 'backbone';
import eventBus         from 'EventBus.js';

import nameTemplate from 'report/properties/main/filter-type.ejs';


class MainFilterTypeView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change select' :'updateFilterType'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateFilterType(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        this.model.set( propName, propVal );
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));

            $(`select[name="type"] option[value="${this.model.get('type')}"]`).prop('selected',true);
            $(`select[name="operator"] option[value="${this.model.get('operator')}"]`).prop('selected',true);
        }
        this.delegateEvents();
        return this;
    }

}

export default MainFilterTypeView;
